import styled from "styled-components";


export const PanicButtonSVGIconClassName = "panic-button-svg-icon";

export const PanicButtonBox = styled.div`
    width: 15.7rem;
    height: 2.7rem;

    .${PanicButtonSVGIconClassName} {
        width: 100%;
        height: auto;
    }
   
`;
